import React from 'react';
import PropTypes from 'prop-types';
import {WalkingMan} from '@spothero/icons';
import {Box, Icon, Text} from '@spothero/ui';
import StarRating from './SpotStarRating';

import {spotDetailsStyleProps, spotNameStyleProps} from './SpotListStyleProps';

function SpotDetails({spot}) {
    const facilityName = spot?.facility?.common?.title;
    const walkingTime = spot?.distance?.duration_seconds;
    const meterDistance = spot?.distance?.walking_meters;
    const distanceMiles = `(${(meterDistance / 1609).toFixed(1)} miles)`;
    const timeMinutes = `${(walkingTime / 60).toFixed(0)} min `;

    return (
        <Box display="flex" flexDirection="column">
            <Box {...spotDetailsStyleProps}>
                <Text
                    {...spotNameStyleProps}
                    overflow="hidden"
                    textOverflow="ellipsis"
                >
                    {facilityName}
                </Text>
                <StarRating spot={spot} />
                <Box display="flex" flexDirection="row" alignItems="center">
                    <Icon as={WalkingMan} height=".75rem" />
                    <Text
                        fontSize=".75rem"
                        whiteSpace="nowrap"
                        fontWeight="semibold"
                        paddingX=".25rem"
                    >
                        {timeMinutes}
                    </Text>{' '}
                    <Text
                        fontSize=".75rem"
                        whiteSpace="nowrap"
                        color="gray"
                        paddingX=".125rem"
                    >
                        {distanceMiles}
                    </Text>
                </Box>
            </Box>
        </Box>
    );
}

SpotDetails.propTypes = {
    spot: PropTypes.object.isRequired,
};

export default SpotDetails;
